import { useQuery } from '@tanstack/react-query';
import { getCurrentUser } from '../api/user';
import { useAuth } from '../contexts/AuthContext';

export const CURRENT_USER_QUERY_KEY = ['current-user'] as const;

export function useCurrentUser() {
  const { user: firebaseUser, loading: authLoading } = useAuth();

  return useQuery({
    queryKey: CURRENT_USER_QUERY_KEY,
    queryFn: getCurrentUser,
    enabled: !authLoading && !!firebaseUser,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    retry: 0,
  });
}